import { useTranslation } from 'react-i18next';
import { finds } from '@/mocks/finds';

const findImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Retro%20Nike%20sneakers%20floating%20composition%20against%20pastel%20mint%20to%20peach%20gradient%20backdrop%20with%203D%20glossy%20reflections%20modern%20advertising%20aesthetic%20editorial%20product%20photography%20clean%20minimal%20showcase&width=512&height=512&seq=find-v2-01&orientation=squarish',
  2: 'https://readdy.ai/api/search-image?query=Heavyweight%20cotton%20hoodie%20displayed%20on%20invisible%20mannequin%20against%20raw%20umber%20stucco%20wall%20with%20dramatic%20spotlight%20creating%20museum%20gallery%20atmosphere%20luxury%20streetwear%20editorial%20photography%20rich%20texture%20emphasis&width=512&height=512&seq=find-v2-02&orientation=squarish',
  3: 'https://readdy.ai/api/search-image?query=Vintage%20workwear%20chore%20jacket%20laid%20flat%20on%20weathered%20reclaimed%20wood%20surface%20with%20antique%20brass%20measuring%20tape%20and%20tailor%20scissors%20heritage%20craftsmanship%20aesthetic%20golden%20afternoon%20light%20editorial%20detail%20photography&width=512&height=512&seq=find-v2-03&orientation=squarish',
  4: 'https://readdy.ai/api/search-image?query=Box%20logo%20tshirt%20suspended%20mid%20air%20against%20cerulean%20blue%20paper%20backdrop%20with%20motion%20blur%20effects%20and%20light%20particles%20dynamic%20editorial%20fashion%20photography%20energetic%20cool%20aesthetic&width=512&height=512&seq=find-v2-04&orientation=squarish',
  5: 'https://readdy.ai/api/search-image?query=Fitted%20baseball%20cap%20perched%20on%20concrete%20ledge%20overlooking%20city%20skyline%20at%20blue%20hour%20twilight%20urban%20skyline%20silhouette%20in%20background%20moody%20street%20style%20editorial%20photography%20atmospheric%20glow&width=512&height=512&seq=find-v2-05&orientation=squarish',
  6: 'https://readdy.ai/api/search-image?query=Premium%20loungewear%20set%20artfully%20draped%20over%20velvet%20accent%20chair%20in%20sun%20drenched%20reading%20nook%20with%20trailing%20ivy%20and%20stacked%20books%20soft%20cream%20and%20oatmeal%20palette%20cozy%20luxury%20editorial%20photography&width=512&height=512&seq=find-v2-06&orientation=squarish',
};

export default function HotFinds() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              {t('finds.title')}{' '}
              <span className="text-accent-500">{t('finds.year')}</span>
            </h2>
            <p className="text-foreground-500 text-xs md:text-sm mt-2">
              {t('finds.subtitle')}
            </p>
          </div>
          <span className="hidden md:inline-block px-4 py-1.5 bg-foreground-900 text-white text-xs font-medium rounded-full whitespace-nowrap">
            {t('finds.badge')}
          </span>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:-mx-6 md:px-6" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {finds.map((item) => (
            <div
              key={item.id}
              className="flex-shrink-0 w-56 md:w-64 bg-white rounded-2xl overflow-hidden group"
            >
              <div className="aspect-square bg-background-100 overflow-hidden">
                <img
                  src={findImages[item.id]}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <p className="text-foreground-400 text-xs mb-1">{item.category}</p>
                <h3 className="text-foreground-900 text-sm font-medium mb-2 line-clamp-2">{item.name}</h3>
                <span className="text-foreground-950 text-base font-bold">{item.rating}</span>
              </div>
            </div>
          ))}
          <div className="flex-shrink-0 w-56 md:w-64 bg-background-100/50 rounded-2xl flex items-center justify-center">
            <div className="w-10 h-10 flex items-center justify-center text-foreground-300">
              <i className="ri-arrow-right-line text-2xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}